const dayjs = require("dayjs");
const utc = require("dayjs/plugin/utc");
dayjs.extend(utc);

export const checkIsDayBefore = (date: string): boolean => {
  const currentDate = dayjs.utc();
  const compareDate = dayjs.utc(date);
  return compareDate.isBefore(currentDate);
};
